var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactformillustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 703.02,
    height: 536.777,
    viewBox: "0 0 703.02 536.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210321"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 196.978,
    cy: 28.875,
    rx: 196.978,
    ry: 28.875,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 196.978,
    cy: 28.875,
    rx: 196.978,
    ry: 28.875,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-540",
    y1: -0.131,
    y2: 1.088,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-551",
    x1: -0.013,
    y1: -0.351,
    x2: 0.798,
    y2: 1.181,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-552",
    x1: -0.084,
    y1: 0.01,
    x2: 1.147,
    y2: 1.256,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_",
    "data-name": "contact ",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3181",
    "data-name": "Group 3181",
    transform: "translate(54.617 334.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10457",
    "data-name": "Path 10457",
    d: "M154.2,282.729l6.939-4.029,6.939,4.029-6.939,4.029Z",
    transform: "translate(-154.2 -278.7)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10458",
    "data-name": "Path 10458",
    d: "M160.7,286.529l6.939-4.029,6.939,4.029-6.939,4.029Z",
    transform: "translate(-146.151 -273.994)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10459",
    "data-name": "Path 10459",
    d: "M167.2,290.329l6.939-4.029,6.939,4.029-6.939,4.029Z",
    transform: "translate(-138.101 -269.288)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10460",
    "data-name": "Path 10460",
    d: "M173.8,294.029,180.739,290l6.939,4.029-6.939,4.029Z",
    transform: "translate(-129.928 -264.706)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10461",
    "data-name": "Path 10461",
    d: "M180.3,297.829l6.939-4.029,6.939,4.029-6.939,4.029Z",
    transform: "translate(-121.878 -260)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439",
    transform: "translate(180.248 407.677)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3182",
    "data-name": "Group 3182",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 393.956,
    height: 57.974,
    transform: "translate(0 -0.224)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3183",
    "data-name": "Group 3183",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.995)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 176.385,
    cy: 23.727,
    rx: 176.385,
    ry: 23.727,
    transform: "translate(20.145 6.267)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3184",
    "data-name": "Group 3184",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.992)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 175.713,
    cy: 23.503,
    rx: 175.713,
    ry: 23.503,
    transform: "translate(20.369 6.491)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3185",
    "data-name": "Group 3185",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.988)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 175.042,
    cy: 23.503,
    rx: 175.042,
    ry: 23.503,
    transform: "translate(20.369 6.491)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3186",
    "data-name": "Group 3186",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.985)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 174.37,
    cy: 23.503,
    rx: 174.37,
    ry: 23.503,
    transform: "translate(20.369 6.491)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3187",
    "data-name": "Group 3187",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.982)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 173.699,
    cy: 23.279,
    rx: 173.699,
    ry: 23.279,
    transform: "translate(20.593 6.715)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3188",
    "data-name": "Group 3188",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.978)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 172.804,
    cy: 23.279,
    rx: 172.804,
    ry: 23.279,
    transform: "translate(20.817 6.715)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3189",
    "data-name": "Group 3189",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.974)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 172.132,
    cy: 23.055,
    rx: 172.132,
    ry: 23.055,
    transform: "translate(20.817 6.939)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3190",
    "data-name": "Group 3190",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.971)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 171.461,
    cy: 23.055,
    rx: 171.461,
    ry: 23.055,
    transform: "translate(21.041 6.939)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3191",
    "data-name": "Group 3191",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.968)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 170.789,
    cy: 22.832,
    rx: 170.789,
    ry: 22.832,
    transform: "translate(21.041 7.163)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3192",
    "data-name": "Group 3192",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.965)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 170.118,
    cy: 22.832,
    rx: 170.118,
    ry: 22.832,
    transform: "translate(21.041 7.163)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3193",
    "data-name": "Group 3193",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.962)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 169.446,
    cy: 22.832,
    rx: 169.446,
    ry: 22.832,
    transform: "translate(21.041 7.163)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3194",
    "data-name": "Group 3194",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.958)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 168.774,
    cy: 22.608,
    rx: 168.774,
    ry: 22.608,
    transform: "translate(21.265 7.387)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3195",
    "data-name": "Group 3195",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.954)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 168.103,
    cy: 22.608,
    rx: 168.103,
    ry: 22.608,
    transform: "translate(21.265 7.387)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3196",
    "data-name": "Group 3196",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.951)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 167.431,
    cy: 22.384,
    rx: 167.431,
    ry: 22.384,
    transform: "translate(21.265 7.611)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3197",
    "data-name": "Group 3197",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.947)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 166.76,
    cy: 22.384,
    rx: 166.76,
    ry: 22.384,
    transform: "translate(21.489 7.611)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3198",
    "data-name": "Group 3198",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.944)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 166.088,
    cy: 22.384,
    rx: 166.088,
    ry: 22.384,
    transform: "translate(21.489 7.611)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3199",
    "data-name": "Group 3199",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.941)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 165.193,
    cy: 22.16,
    rx: 165.193,
    ry: 22.16,
    transform: "translate(21.712 7.834)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3200",
    "data-name": "Group 3200",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.937)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 164.522,
    cy: 22.16,
    rx: 164.522,
    ry: 22.16,
    transform: "translate(21.936 7.834)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3201",
    "data-name": "Group 3201",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10462",
    "data-name": "Path 10462",
    d: "M548.024,336.749c0,12.087-73.2,22.384-163.85,22.832-90.431.448-164.074-8.954-164.074-21.041s73.2-22.384,163.85-22.832S548.024,324.662,548.024,336.749Z",
    transform: "translate(-198.388 -307.65)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3202",
    "data-name": "Group 3202",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.93)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 163.178,
    cy: 21.936,
    rx: 163.178,
    ry: 21.936,
    transform: "translate(21.936 8.058)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3203",
    "data-name": "Group 3203",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.927)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 162.507,
    cy: 21.712,
    rx: 162.507,
    ry: 21.712,
    transform: "translate(21.936 8.282)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.924)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_250",
    "data-name": "Ellipse 250",
    cx: 161.835,
    cy: 21.712,
    rx: 161.835,
    ry: 21.712,
    transform: "translate(22.16 8.282)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3205",
    "data-name": "Group 3205",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.921)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    cx: 161.164,
    cy: 21.712,
    rx: 161.164,
    ry: 21.712,
    transform: "translate(22.16 8.282)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3206",
    "data-name": "Group 3206",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.917)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 160.492,
    cy: 21.489,
    rx: 160.492,
    ry: 21.489,
    transform: "translate(22.16 8.506)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3207",
    "data-name": "Group 3207",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.914)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 159.821,
    cy: 21.489,
    rx: 159.821,
    ry: 21.489,
    transform: "translate(22.384 8.506)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3208",
    "data-name": "Group 3208",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.91)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 159.149,
    cy: 21.265,
    rx: 159.149,
    ry: 21.265,
    transform: "translate(22.384 8.73)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3209",
    "data-name": "Group 3209",
    transform: "matrix(1, -0.006, 0.006, 1, 0.007, 2.906)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 158.478,
    cy: 21.265,
    rx: 158.478,
    ry: 21.265,
    transform: "translate(22.384 8.73)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3210",
    "data-name": "Group 3210",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.903)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 157.583,
    cy: 21.265,
    rx: 157.583,
    ry: 21.265,
    transform: "translate(22.832 8.73)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3211",
    "data-name": "Group 3211",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10463",
    "data-name": "Path 10463",
    d: "M534.546,336.365c0,11.64-70.061,21.489-156.911,21.936-86.626.448-157.135-8.506-157.135-20.145s70.062-21.489,156.911-21.936C464.26,315.548,534.546,324.725,534.546,336.365Z",
    transform: "translate(-197.892 -307.042)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3212",
    "data-name": "Group 3212",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.897)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 156.24,
    cy: 21.041,
    rx: 156.24,
    ry: 21.041,
    transform: "translate(22.832 8.954)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3213",
    "data-name": "Group 3213",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.893)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 155.568,
    cy: 20.817,
    rx: 155.568,
    ry: 20.817,
    transform: "translate(22.832 9.401)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3214",
    "data-name": "Group 3214",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10464",
    "data-name": "Path 10464",
    d: "M530.617,336.241c0,11.416-69.166,21.265-154.9,21.712-85.506.448-154.9-8.506-155.12-19.922,0-11.416,69.166-21.265,154.9-21.712C461,315.648,530.617,324.6,530.617,336.241Z",
    transform: "translate(-197.768 -306.918)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3215",
    "data-name": "Group 3215",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.886)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 154.225,
    cy: 20.817,
    rx: 154.225,
    ry: 20.817,
    transform: "translate(23.055 9.401)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3216",
    "data-name": "Group 3216",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.883)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 153.553,
    cy: 20.593,
    rx: 153.553,
    ry: 20.593,
    transform: "translate(23.055 9.625)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3217",
    "data-name": "Group 3217",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.88)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_274",
    "data-name": "Ellipse 274",
    cx: 152.882,
    cy: 20.593,
    rx: 152.882,
    ry: 20.593,
    transform: "translate(23.279 9.625)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.876)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 152.21,
    cy: 20.369,
    rx: 152.21,
    ry: 20.369,
    transform: "translate(23.279 9.849)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3219",
    "data-name": "Group 3219",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.873)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    cx: 151.539,
    cy: 20.369,
    rx: 151.539,
    ry: 20.369,
    transform: "translate(23.279 9.849)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3220",
    "data-name": "Group 3220",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.87)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 150.867,
    cy: 20.145,
    rx: 150.867,
    ry: 20.145,
    transform: "translate(23.503 10.073)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3221",
    "data-name": "Group 3221",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.865)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 150.196,
    cy: 20.145,
    rx: 150.196,
    ry: 20.145,
    transform: "translate(23.503 10.073)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.862)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 149.301,
    cy: 20.145,
    rx: 149.301,
    ry: 20.145,
    transform: "translate(23.727 10.073)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3223",
    "data-name": "Group 3223",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10465",
    "data-name": "Path 10465",
    d: "M518.482,335.746c0,10.968-66.48,20.369-148.629,20.817S221,348.505,221,337.537s66.48-20.369,148.629-20.817C451.778,316.049,518.482,324.778,518.482,335.746Z",
    transform: "translate(-197.273 -306.424)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3224",
    "data-name": "Group 3224",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.855)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    cx: 147.957,
    cy: 19.922,
    rx: 147.957,
    ry: 19.922,
    transform: "translate(23.951 10.297)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3225",
    "data-name": "Group 3225",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.853)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    cx: 147.286,
    cy: 19.698,
    rx: 147.286,
    ry: 19.698,
    transform: "translate(23.951 10.52)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10466",
    "data-name": "Path 10466",
    d: "M514.453,335.612c0,10.968-65.585,20.146-146.614,20.593S221.224,348.147,221,337.4c0-10.968,65.585-20.145,146.614-20.593C448.868,316.362,514.453,324.644,514.453,335.612Z",
    transform: "translate(-197.273 -306.289)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10467",
    "data-name": "Path 10467",
    d: "M512.962,335.612c0,10.744-65.137,19.922-145.719,20.369S221.3,347.923,221.3,337.179s65.137-19.922,145.719-20.369C447.377,316.362,512.738,324.868,512.962,335.612Z",
    transform: "translate(-196.902 -306.289)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10468",
    "data-name": "Path 10468",
    d: "M511.619,335.488c0,10.744-64.913,19.922-145.047,20.369S221.3,348.023,221.3,337.279s64.913-19.922,145.048-20.369S511.619,324.744,511.619,335.488Z",
    transform: "translate(-196.902 -306.165)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3229",
    "data-name": "Group 3229",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10469",
    "data-name": "Path 10469",
    d: "M510.276,335.488c0,10.744-64.689,19.7-144.376,20.146-79.91.448-144.6-7.834-144.6-18.579s64.689-19.7,144.376-20.145S510.276,324.744,510.276,335.488Z",
    transform: "translate(-196.902 -306.165)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3230",
    "data-name": "Group 3230",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.835)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_295",
    "data-name": "Ellipse 295",
    cx: 143.928,
    cy: 19.25,
    rx: 143.928,
    ry: 19.25,
    transform: "translate(24.398 10.968)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3231",
    "data-name": "Group 3231",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10470",
    "data-name": "Path 10470",
    d: "M507.59,335.364c0,10.52-64.018,19.474-143.033,19.922S221.3,347.452,221.3,336.931s64.018-19.474,143.033-19.922C443.572,316.562,507.59,324.844,507.59,335.364Z",
    transform: "translate(-196.902 -306.042)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3232",
    "data-name": "Group 3232",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.829)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 142.585,
    cy: 19.026,
    rx: 142.585,
    ry: 19.026,
    transform: "translate(24.398 11.192)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.825)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 141.69,
    cy: 19.026,
    rx: 141.69,
    ry: 19.026,
    transform: "translate(24.622 11.192)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10471",
    "data-name": "Path 10471",
    d: "M503.661,335.241c0,10.521-63.123,19.25-141.018,19.7S221.4,347.328,221.4,336.807s63.123-19.25,141.019-19.7S503.661,324.944,503.661,335.241Z",
    transform: "translate(-196.778 -305.918)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10472",
    "data-name": "Path 10472",
    d: "M502.318,335.234c0,10.521-62.675,19.25-140.347,19.7S221.624,347.321,221.4,336.8c0-10.52,62.675-19.25,140.347-19.7C439.419,316.879,502.318,324.937,502.318,335.234Z",
    transform: "translate(-196.778 -305.911)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3236",
    "data-name": "Group 3236",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.815)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 139.675,
    cy: 18.802,
    rx: 139.675,
    ry: 18.802,
    transform: "translate(24.846 11.416)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3237",
    "data-name": "Group 3237",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.811)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    cx: 139.004,
    cy: 18.579,
    rx: 139.004,
    ry: 18.579,
    transform: "translate(25.07 11.64)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3238",
    "data-name": "Group 3238",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10473",
    "data-name": "Path 10473",
    d: "M498.141,334.993c0,10.3-61.779,19.026-138.109,19.25C283.7,354.691,221.7,346.633,221.7,336.56c0-10.3,61.78-19.026,138.109-19.25C436.138,316.862,498.141,324.92,498.141,334.993Z",
    transform: "translate(-196.406 -305.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10474",
    "data-name": "Path 10474",
    d: "M496.8,334.993c0,10.3-61.556,18.8-137.437,19.25-76.105.448-137.661-7.387-137.661-17.683s61.556-18.8,137.437-19.25S496.8,324.92,496.8,334.993Z",
    transform: "translate(-196.406 -305.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.801)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 136.989,
    cy: 18.355,
    rx: 136.989,
    ry: 18.355,
    transform: "translate(25.294 11.863)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3241",
    "data-name": "Group 3241",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.797)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 136.318,
    cy: 18.355,
    rx: 136.318,
    ry: 18.355,
    transform: "translate(25.294 11.863)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3242",
    "data-name": "Group 3242",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.794)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 135.646,
    cy: 18.131,
    rx: 135.646,
    ry: 18.131,
    transform: "translate(25.294 12.087)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3243",
    "data-name": "Group 3243",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.791)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 134.975,
    cy: 18.131,
    rx: 134.975,
    ry: 18.131,
    transform: "translate(25.518 12.087)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3244",
    "data-name": "Group 3244",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.788)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 134.079,
    cy: 17.907,
    rx: 134.079,
    ry: 17.907,
    transform: "translate(25.741 12.311)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3245",
    "data-name": "Group 3245",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.784)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 133.408,
    cy: 17.907,
    rx: 133.408,
    ry: 17.907,
    transform: "translate(25.741 12.311)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3246",
    "data-name": "Group 3246",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10475",
    "data-name": "Path 10475",
    d: "M487.6,334.734c0,9.849-59.317,18.131-132.736,18.579S222.124,346.15,221.9,336.3c0-9.849,59.317-18.131,132.736-18.579C428.056,317.051,487.373,324.885,487.6,334.734Z",
    transform: "translate(-196.158 -305.187)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3247",
    "data-name": "Group 3247",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10476",
    "data-name": "Path 10476",
    d: "M486.254,334.722c0,9.849-59.093,18.131-132.065,18.579S222.124,346.138,221.9,336.289c0-9.849,59.093-18.131,132.065-18.579S486.254,324.873,486.254,334.722Z",
    transform: "translate(-196.159 -305.175)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3248",
    "data-name": "Group 3248",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.773)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    cx: 131.393,
    cy: 17.683,
    rx: 131.393,
    ry: 17.683,
    transform: "translate(25.965 12.535)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3249",
    "data-name": "Group 3249",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10477",
    "data-name": "Path 10477",
    d: "M483.444,334.6c0,9.625-58.422,17.907-130.722,18.355S222,345.791,222,336.166s58.422-17.907,130.722-18.355C424.8,317.363,483.444,324.75,483.444,334.6Z",
    transform: "translate(-196.035 -305.052)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10478",
    "data-name": "Path 10478",
    d: "M482.077,334.6c0,9.625-58.2,17.683-129.826,18.131-71.852.448-130.05-7.163-130.05-16.788s58.2-17.683,129.827-18.131S481.853,324.973,482.077,334.6Z",
    transform: "translate(-195.787 -305.052)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3251",
    "data-name": "Group 3251",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10479",
    "data-name": "Path 10479",
    d: "M480.734,334.475c0,9.625-57.75,17.683-129.155,18.131S222.2,345.667,222.2,336.042s57.75-17.683,129.155-18.131S480.51,324.85,480.734,334.475Z",
    transform: "translate(-195.787 -304.928)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3252",
    "data-name": "Group 3252",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10480",
    "data-name": "Path 10480",
    d: "M479.391,334.475c0,9.625-57.527,17.683-128.484,17.907-70.957.448-128.707-6.939-128.707-16.564s57.527-17.683,128.484-17.907C421.64,317.463,479.391,324.85,479.391,334.475Z",
    transform: "translate(-195.787 -304.928)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3253",
    "data-name": "Group 3253",
    transform: "matrix(1, -0.006, 0.006, 1, 0.006, 2.756)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 128.036,
    cy: 17.236,
    rx: 128.036,
    ry: 17.236,
    transform: "translate(26.413 12.983)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3254",
    "data-name": "Group 3254",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.753)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    cx: 127.364,
    cy: 17.012,
    rx: 127.364,
    ry: 17.012,
    transform: "translate(26.413 13.206)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3255",
    "data-name": "Group 3255",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10481",
    "data-name": "Path 10481",
    d: "M475.462,334.351c0,9.4-56.631,17.236-126.469,17.683S222.3,345.1,222.3,335.694s56.631-17.236,126.469-17.683S475.238,324.95,475.462,334.351Z",
    transform: "translate(-195.663 -304.804)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3256",
    "data-name": "Group 3256",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.747)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_335",
    "data-name": "Ellipse 335",
    cx: 125.797,
    cy: 16.788,
    rx: 125.797,
    ry: 16.788,
    transform: "translate(26.637 13.43)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3257",
    "data-name": "Group 3257",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.743)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 125.126,
    cy: 16.788,
    rx: 125.126,
    ry: 16.788,
    transform: "translate(26.861 13.43)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10482",
    "data-name": "Path 10482",
    d: "M471.433,334.219c0,9.177-55.736,17.012-124.454,17.459S222.524,344.963,222.3,335.562c0-9.177,55.736-17.012,124.454-17.459C415.7,317.879,471.433,325.042,471.433,334.219Z",
    transform: "translate(-195.663 -304.673)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10483",
    "data-name": "Path 10483",
    d: "M469.966,334.1c0,9.177-55.288,17.012-123.783,17.236S222.4,344.616,222.4,335.439s55.288-17.012,123.783-17.236S469.966,324.918,469.966,334.1Z",
    transform: "translate(-195.539 -304.549)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3260",
    "data-name": "Group 3260",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.733)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 123.111,
    cy: 16.564,
    rx: 123.111,
    ry: 16.564,
    transform: "translate(27.085 13.654)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3261",
    "data-name": "Group 3261",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.729)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 122.44,
    cy: 16.34,
    rx: 122.44,
    ry: 16.34,
    transform: "translate(27.085 13.878)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3262",
    "data-name": "Group 3262",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10484",
    "data-name": "Path 10484",
    d: "M465.913,333.98c0,8.954-54.393,16.564-121.544,17.012S222.6,344.276,222.6,335.323s54.393-16.564,121.544-17.012S465.913,325.026,465.913,333.98Z",
    transform: "translate(-195.292 -304.433)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3263",
    "data-name": "Group 3263",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10485",
    "data-name": "Path 10485",
    d: "M464.57,333.972c0,8.954-54.169,16.564-120.873,17.012-66.928.448-121.1-6.491-121.1-15.669,0-8.954,54.169-16.564,120.873-17.012C410.4,318.079,464.57,325.018,464.57,333.972Z",
    transform: "translate(-195.292 -304.425)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3264",
    "data-name": "Group 3264",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 120.425,
    cy: 16.116,
    rx: 120.425,
    ry: 16.116,
    transform: "translate(27.308 14.102)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3265",
    "data-name": "Group 3265",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10486",
    "data-name": "Path 10486",
    d: "M461.984,333.848c0,8.954-53.5,16.34-119.53,16.788S222.7,344.144,222.7,335.191s53.5-16.34,119.53-16.788C408.262,318.179,461.76,325.118,461.984,333.848Z",
    transform: "translate(-195.168 -304.301)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10487",
    "data-name": "Path 10487",
    d: "M460.641,333.732c0,8.73-53.274,16.34-118.858,16.564-65.809.448-119.082-6.491-119.082-15.221s53.274-16.34,118.858-16.564C407.367,318.064,460.641,325,460.641,333.732Z",
    transform: "translate(-195.168 -304.186)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3267",
    "data-name": "Group 3267",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.709)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_351",
    "data-name": "Ellipse 351",
    cx: 118.187,
    cy: 15.893,
    rx: 118.187,
    ry: 15.893,
    transform: "translate(27.756 14.326)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3268",
    "data-name": "Group 3268",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.706)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_353",
    "data-name": "Ellipse 353",
    cx: 117.515,
    cy: 15.893,
    rx: 117.515,
    ry: 15.893,
    transform: "translate(27.756 14.326)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3269",
    "data-name": "Group 3269",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.703)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_355",
    "data-name": "Ellipse 355",
    cx: 116.844,
    cy: 15.669,
    rx: 116.844,
    ry: 15.669,
    transform: "translate(27.756 14.55)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.699)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 116.172,
    cy: 15.669,
    rx: 116.172,
    ry: 15.669,
    transform: "translate(27.98 14.55)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3271",
    "data-name": "Group 3271",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10488",
    "data-name": "Path 10488",
    d: "M453.9,333.485c0,8.506-51.707,15.893-115.5,16.116-63.794.448-115.5-6.267-115.5-14.773s51.707-15.893,115.5-16.116C402.195,318.264,453.9,324.979,453.9,333.485Z",
    transform: "translate(-194.92 -303.938)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3272",
    "data-name": "Group 3272",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.692)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 114.829,
    cy: 15.445,
    rx: 114.829,
    ry: 15.445,
    transform: "translate(27.98 14.773)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3273",
    "data-name": "Group 3273",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10489",
    "data-name": "Path 10489",
    d: "M451.092,333.476c0,8.506-51.035,15.669-113.934,15.893C274.035,349.817,223,343.1,223,334.6s51.035-15.669,113.934-15.893C400.057,318.479,451.092,325.194,451.092,333.476Z",
    transform: "translate(-194.796 -303.93)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3274",
    "data-name": "Group 3274",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.685)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_363",
    "data-name": "Ellipse 363",
    cx: 113.486,
    cy: 15.221,
    rx: 113.486,
    ry: 15.221,
    transform: "translate(28.204 14.997)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3275",
    "data-name": "Group 3275",
    transform: "matrix(1, -0.006, 0.006, 1, 0.005, 2.682)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_365",
    "data-name": "Ellipse 365",
    cx: 112.815,
    cy: 15.221,
    rx: 112.815,
    ry: 15.221,
    transform: "translate(28.204 14.997)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.679)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 112.143,
    cy: 14.997,
    rx: 112.143,
    ry: 14.997,
    transform: "translate(28.204 15.221)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3277",
    "data-name": "Group 3277",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.675)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 111.248,
    cy: 14.997,
    rx: 111.248,
    ry: 14.997,
    transform: "translate(28.651 15.221)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3278",
    "data-name": "Group 3278",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10490",
    "data-name": "Path 10490",
    d: "M444.477,333.338c0,8.282-49.468,15.221-110.576,15.445s-110.8-6.044-110.8-14.326,49.468-15.221,110.576-15.445C395.008,318.564,444.477,325.056,444.477,333.338Z",
    transform: "translate(-194.672 -303.567)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3279",
    "data-name": "Group 3279",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10491",
    "data-name": "Path 10491",
    d: "M443.233,333.214c0,8.058-49.245,15-109.9,15.445s-109.9-6.044-110.129-14.1c0-8.058,49.244-15,109.9-15.445S443.01,324.932,443.233,333.214Z",
    transform: "translate(-194.549 -303.444)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3280",
    "data-name": "Group 3280",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.665)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    cx: 109.233,
    cy: 14.773,
    rx: 109.233,
    ry: 14.773,
    transform: "translate(28.875 15.445)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3281",
    "data-name": "Group 3281",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.661)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 108.562,
    cy: 14.55,
    rx: 108.562,
    ry: 14.55,
    transform: "translate(28.875 15.669)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3282",
    "data-name": "Group 3282",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10492",
    "data-name": "Path 10492",
    d: "M439.081,333.091c0,8.058-48.125,14.773-107.89,15-59.541.448-107.89-5.82-107.89-13.878s48.125-14.773,107.89-15C390.731,318.765,439.081,325.032,439.081,333.091Z",
    transform: "translate(-194.425 -303.32)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3283",
    "data-name": "Group 3283",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10493",
    "data-name": "Path 10493",
    d: "M437.838,333.081c0,8.058-47.9,14.773-107.219,15S223.4,342.259,223.4,334.2s47.9-14.773,107.219-15C389.712,318.98,437.614,325.023,437.838,333.081Z",
    transform: "translate(-194.301 -303.311)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3284",
    "data-name": "Group 3284",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_379",
    "data-name": "Ellipse 379",
    cx: 106.547,
    cy: 14.326,
    rx: 106.547,
    ry: 14.326,
    transform: "translate(29.099 15.893)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10494",
    "data-name": "Path 10494",
    d: "M435.028,332.958c0,7.834-47.23,14.55-105.652,14.773S223.5,341.911,223.5,334.077s47.23-14.55,105.652-14.773S435.028,325.123,435.028,332.958Z",
    transform: "translate(-194.177 -303.187)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3286",
    "data-name": "Group 3286",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10495",
    "data-name": "Path 10495",
    d: "M433.685,332.843c0,7.834-47.006,14.326-104.98,14.773-57.974.224-105.2-5.82-105.2-13.43,0-7.834,47.006-14.326,104.98-14.773C386.679,318.965,433.685,325.009,433.685,332.843Z",
    transform: "translate(-194.177 -303.073)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3287",
    "data-name": "Group 3287",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.641)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_383",
    "data-name": "Ellipse 383",
    cx: 104.533,
    cy: 14.102,
    rx: 104.533,
    ry: 14.102,
    transform: "translate(29.323 16.34)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3288",
    "data-name": "Group 3288",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.638)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 103.637,
    cy: 13.878,
    rx: 103.637,
    ry: 13.878,
    transform: "translate(29.547 16.564)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3289",
    "data-name": "Group 3289",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10496",
    "data-name": "Path 10496",
    d: "M429.756,332.719c0,7.611-46.111,14.1-102.966,14.326s-103.19-5.6-103.19-13.206,46.111-14.1,102.966-14.326C383.421,319.065,429.756,325.109,429.756,332.719Z",
    transform: "translate(-194.053 -302.949)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3290",
    "data-name": "Group 3290",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.631)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 102.294,
    cy: 13.654,
    rx: 102.294,
    ry: 13.654,
    transform: "translate(29.771 16.788)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3291",
    "data-name": "Group 3291",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10497",
    "data-name": "Path 10497",
    d: "M427.07,332.6c0,7.611-45.439,13.878-101.623,14.326-56.184.224-101.623-5.6-101.847-12.983,0-7.611,45.439-13.878,101.623-14.326C381.63,319.166,427.07,324.986,427.07,332.6Z",
    transform: "translate(-194.053 -302.826)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3292",
    "data-name": "Group 3292",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.624)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 100.951,
    cy: 13.654,
    rx: 100.951,
    ry: 13.654,
    transform: "translate(29.771 16.788)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10498",
    "data-name": "Path 10498",
    d: "M424.36,332.586c0,7.387-44.768,13.654-100.28,14.1-55.288.224-100.28-5.372-100.28-12.983,0-7.387,44.768-13.654,100.28-14.1C379.368,319.38,424.136,325.2,424.36,332.586Z",
    transform: "translate(-193.806 -302.816)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10499",
    "data-name": "Path 10499",
    d: "M423.017,332.472c0,7.387-44.544,13.654-99.608,13.878S223.8,340.978,223.8,333.591s44.544-13.654,99.608-13.878C378.249,319.266,423.017,325.086,423.017,332.472Z",
    transform: "translate(-193.806 -302.702)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.614)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 98.937,
    cy: 13.206,
    rx: 98.937,
    ry: 13.206,
    transform: "translate(29.994 17.236)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.61)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 98.265,
    cy: 13.206,
    rx: 98.265,
    ry: 13.206,
    transform: "translate(30.218 17.236)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3297",
    "data-name": "Group 3297",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10500",
    "data-name": "Path 10500",
    d: "M418.864,332.339c0,7.163-43.648,13.43-97.37,13.654-53.945.224-97.594-5.372-97.594-12.535s43.649-13.43,97.37-13.654S418.864,325.176,418.864,332.339Z",
    transform: "translate(-193.682 -302.568)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3298",
    "data-name": "Group 3298",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10501",
    "data-name": "Path 10501",
    d: "M417.621,332.339c0,7.163-43.2,13.207-96.7,13.654-53.5.224-96.922-5.372-96.922-12.535s43.2-13.206,96.7-13.654C374.2,319.58,417.621,325.176,417.621,332.339Z",
    transform: "translate(-193.558 -302.568)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3299",
    "data-name": "Group 3299",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 96.027,
    cy: 12.983,
    rx: 96.027,
    ry: 12.983,
    transform: "translate(30.442 17.459)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3300",
    "data-name": "Group 3300",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10502",
    "data-name": "Path 10502",
    d: "M414.934,332.215c0,7.163-42.753,12.983-95.355,13.43-52.6.224-95.579-5.148-95.579-12.311s42.753-12.983,95.355-13.43C372.181,319.68,414.934,325.276,414.934,332.215Z",
    transform: "translate(-193.558 -302.444)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.593)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_404",
    "data-name": "Ellipse 404",
    cx: 94.684,
    cy: 12.759,
    rx: 94.684,
    ry: 12.759,
    transform: "translate(30.666 17.683)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10503",
    "data-name": "Path 10503",
    d: "M412.349,332.091c0,6.939-42.082,12.759-94.012,13.207-51.931.224-94.012-5.148-94.236-12.087,0-6.939,42.082-12.759,94.012-13.206C370.043,319.78,412.125,325.152,412.349,332.091Z",
    transform: "translate(-193.434 -302.321)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10504",
    "data-name": "Path 10504",
    d: "M410.882,332.091c0,6.939-41.634,12.759-93.341,12.983-51.483.224-93.341-5.148-93.341-12.087S265.834,320.228,317.541,320C369.024,319.78,410.882,325.152,410.882,332.091Z",
    transform: "translate(-193.31 -302.321)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10505",
    "data-name": "Path 10505",
    d: "M409.539,331.967c0,6.939-41.41,12.759-92.669,12.983S224.2,339.8,224.2,333.086c0-6.939,41.41-12.759,92.669-12.983C367.9,319.88,409.539,325.252,409.539,331.967Z",
    transform: "translate(-193.31 -302.197)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10506",
    "data-name": "Path 10506",
    d: "M408.2,331.967c0,6.715-41.186,12.535-92,12.759s-92-4.924-92-11.863c0-6.715,41.186-12.535,92-12.759S408.2,325.252,408.2,331.967Z",
    transform: "translate(-193.31 -302.197)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10507",
    "data-name": "Path 10507",
    d: "M406.852,331.844c0,6.715-40.739,12.535-91.326,12.759-50.364.224-91.326-4.924-91.326-11.64s40.739-12.535,91.326-12.759C365.89,319.98,406.852,325.128,406.852,331.844Z",
    transform: "translate(-193.31 -302.073)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M405.486,331.955c0,6.715-40.515,12.311-90.431,12.759-50.14.224-90.655-4.924-90.655-11.64s40.515-12.311,90.431-12.759S405.262,325.016,405.486,331.955Z",
    transform: "translate(-193.063 -301.96)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.57)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 89.983,
    cy: 12.087,
    rx: 89.983,
    ry: 12.087,
    transform: "translate(31.114 18.355)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10509",
    "data-name": "Path 10509",
    d: "M402.8,331.831c0,6.715-39.843,12.311-89.088,12.535S224.4,339.441,224.4,332.95c0-6.715,39.843-12.311,89.088-12.535C362.732,319.967,402.8,325.116,402.8,331.831Z",
    transform: "translate(-193.063 -301.836)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M401.457,331.82c0,6.491-39.62,12.087-88.416,12.311s-88.64-4.925-88.64-11.416,39.619-12.087,88.416-12.311S401.457,325.1,401.457,331.82Z",
    transform: "translate(-193.063 -301.826)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M400.113,331.707c0,6.491-39.172,12.087-87.745,12.311s-87.969-4.7-87.969-11.192,39.172-12.087,87.745-12.311C360.718,320.067,400.113,325.216,400.113,331.707Z",
    transform: "translate(-193.063 -301.712)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.555)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 87.073,
    cy: 11.64,
    rx: 87.073,
    ry: 11.64,
    transform: "translate(31.561 18.802)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3313",
    "data-name": "Group 3313",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M397.527,331.7c0,6.491-38.724,11.863-86.4,12.087s-86.4-4.7-86.626-11.192c0-6.491,38.724-11.863,86.4-12.087C358.8,320.28,397.527,325.2,397.527,331.7Z",
    transform: "translate(-192.939 -301.702)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3314",
    "data-name": "Group 3314",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M396.06,331.584c0,6.268-38.276,11.64-85.73,12.087-47.454.224-85.73-4.7-85.73-10.968s38.276-11.64,85.73-12.087C357.56,320.168,396.06,325.092,396.06,331.584Z",
    transform: "translate(-192.815 -301.589)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10514",
    "data-name": "Path 10514",
    d: "M394.717,331.572c0,6.267-38.053,11.64-85.059,11.863s-85.059-4.7-85.059-10.968,38.053-11.64,85.059-11.863S394.717,325.3,394.717,331.572Z",
    transform: "translate(-192.815 -301.578)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10515",
    "data-name": "Path 10515",
    d: "M393.474,331.46c0,6.267-37.6,11.64-84.387,11.863-46.558.224-84.387-4.7-84.387-10.744,0-6.268,37.605-11.64,84.387-11.863C355.422,320.268,393.251,325.193,393.474,331.46Z",
    transform: "translate(-192.691 -301.466)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3317",
    "data-name": "Group 3317",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10516",
    "data-name": "Path 10516",
    d: "M392.131,331.449c0,6.267-37.381,11.416-83.716,11.64-46.111.224-83.716-4.477-83.716-10.744s37.381-11.416,83.716-11.64C354.527,320.48,392.131,325.181,392.131,331.449Z",
    transform: "translate(-192.691 -301.454)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3318",
    "data-name": "Group 3318",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10517",
    "data-name": "Path 10517",
    d: "M390.665,331.449c0,6.044-37.157,11.416-82.82,11.64-45.887.224-83.044-4.477-83.044-10.744,0-6.044,37.157-11.416,82.82-11.64C353.507,320.48,390.665,325.181,390.665,331.449Z",
    transform: "translate(-192.567 -301.454)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.532)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_425",
    "data-name": "Ellipse 425",
    cx: 82.373,
    cy: 10.968,
    rx: 82.373,
    ry: 10.968,
    transform: "translate(32.009 19.474)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10518",
    "data-name": "Path 10518",
    d: "M387.979,331.325c0,6.044-36.486,11.192-81.477,11.416s-81.7-4.477-81.7-10.52,36.486-11.192,81.477-11.416C351.493,320.581,387.979,325.281,387.979,331.325Z",
    transform: "translate(-192.567 -301.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10519",
    "data-name": "Path 10519",
    d: "M386.735,331.213c0,6.044-36.262,10.968-80.806,11.416-44.768.224-81.03-4.477-81.03-10.3,0-6.044,36.262-10.968,80.806-11.416S386.512,325.169,386.735,331.213Z",
    transform: "translate(-192.443 -301.219)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10520",
    "data-name": "Path 10520",
    d: "M385.392,331.2c0,6.044-35.814,10.968-80.134,11.192S224.9,337.916,224.9,332.1s35.814-10.968,80.134-11.192S385.392,325.157,385.392,331.2Z",
    transform: "translate(-192.443 -301.207)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10521",
    "data-name": "Path 10521",
    d: "M384.049,331.2c0,5.82-35.59,10.968-79.463,11.192s-79.463-4.253-79.687-10.3c0-5.82,35.59-10.968,79.463-11.192S384.049,325.381,384.049,331.2Z",
    transform: "translate(-192.443 -301.206)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3324",
    "data-name": "Group 3324",
    transform: "matrix(1, -0.006, 0.006, 1, 0.003, 2.515)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 78.791,
    cy: 10.52,
    rx: 78.791,
    ry: 10.52,
    transform: "translate(32.68 19.922)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10522",
    "data-name": "Path 10522",
    d: "M381.239,331.077c0,5.82-34.919,10.744-78.12,10.968S225,337.792,225,331.973,259.919,321.228,303.12,321,381.239,325.257,381.239,331.077Z",
    transform: "translate(-192.32 -301.083)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3326",
    "data-name": "Group 3326",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10523",
    "data-name": "Path 10523",
    d: "M380,331.073c0,5.82-34.7,10.52-77.448,10.744S225.1,337.564,225.1,331.744s34.7-10.52,77.448-10.744C345.078,321,379.773,325.253,380,331.073Z",
    transform: "translate(-192.196 -301.078)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10524",
    "data-name": "Path 10524",
    d: "M378.653,330.953c0,5.6-34.247,10.52-76.777,10.744-42.306.224-76.777-4.253-76.777-9.849s34.247-10.52,76.777-10.744C344.182,320.881,378.653,325.357,378.653,330.953Z",
    transform: "translate(-192.196 -300.959)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328",
    transform: "matrix(1, -0.006, 0.006, 1, 0.003, 2.502)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    cx: 76.105,
    cy: 10.297,
    rx: 76.105,
    ry: 10.297,
    transform: "translate(32.904 20.145)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10525",
    "data-name": "Path 10525",
    d: "M375.967,330.83c0,5.6-33.8,10.3-75.434,10.52s-75.434-4.029-75.434-9.625,33.8-10.3,75.434-10.52S375.967,325.234,375.967,330.83Z",
    transform: "translate(-192.196 -300.835)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10526",
    "data-name": "Path 10526",
    d: "M374.5,330.83c0,5.6-33.352,10.3-74.538,10.52s-74.762-4.029-74.762-9.625,33.352-10.3,74.538-10.52C341.148,320.981,374.5,325.234,374.5,330.83Z",
    transform: "translate(-192.072 -300.835)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10527",
    "data-name": "Path 10527",
    d: "M373.257,330.83c0,5.6-33.128,10.073-73.867,10.3-40.962.224-74.091-4.029-74.091-9.625s33.128-10.073,73.867-10.3S373.257,325.457,373.257,330.83Z",
    transform: "translate(-191.948 -300.835)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10528",
    "data-name": "Path 10528",
    d: "M371.914,330.706c0,5.372-32.681,10.073-73.2,10.3s-73.419-4.029-73.419-9.4,32.68-10.073,73.2-10.3S371.914,325.334,371.914,330.706Z",
    transform: "translate(-191.948 -300.712)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10529",
    "data-name": "Path 10529",
    d: "M370.571,330.7c0,5.372-32.457,9.849-72.524,10.073s-72.748-4.029-72.748-9.4,32.457-9.849,72.524-10.073C338.115,321.3,370.571,325.329,370.571,330.7Z",
    transform: "translate(-191.948 -300.707)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3334",
    "data-name": "Group 3334",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10530",
    "data-name": "Path 10530",
    d: "M369.228,330.582c0,5.372-32.233,9.849-71.852,10.073s-71.852-4.029-72.076-9.177c0-5.372,32.233-9.849,71.852-10.073C337,321.181,369.228,325.434,369.228,330.582Z",
    transform: "translate(-191.948 -300.588)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3335",
    "data-name": "Group 3335",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10531",
    "data-name": "Path 10531",
    d: "M367.862,330.582c0,5.372-31.785,9.849-71.181,10.073S225.5,336.85,225.5,331.477s31.785-9.849,71.181-10.073C335.853,321.181,367.638,325.434,367.862,330.582Z",
    transform: "translate(-191.7 -300.588)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3336",
    "data-name": "Group 3336",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10532",
    "data-name": "Path 10532",
    d: "M366.519,330.577c0,5.148-31.561,9.625-70.509,9.849s-70.509-3.805-70.509-9.177,31.561-9.625,70.509-9.849C334.733,321.4,366.519,325.429,366.519,330.577Z",
    transform: "translate(-191.7 -300.583)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3337",
    "data-name": "Group 3337",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10533",
    "data-name": "Path 10533",
    d: "M365.175,330.459c0,5.148-31.114,9.625-69.838,9.849-38.5.224-69.838-3.805-69.838-8.954s31.114-9.625,69.838-9.849C333.838,321.281,365.175,325.31,365.175,330.459Z",
    transform: "translate(-191.7 -300.464)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3338",
    "data-name": "Group 3338",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10534",
    "data-name": "Path 10534",
    d: "M363.832,330.454c0,5.148-30.89,9.4-69.166,9.625s-69.166-3.805-69.166-8.954,30.89-9.4,69.166-9.625C332.943,321.5,363.832,325.529,363.832,330.454Z",
    transform: "translate(-191.7 -300.459)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3339",
    "data-name": "Group 3339",
    transform: "matrix(1, -0.006, 0.006, 1, 0.003, 2.464)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 68.495,
    cy: 9.177,
    rx: 68.495,
    ry: 9.177,
    transform: "translate(34.024 21.265)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3340",
    "data-name": "Group 3340",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10535",
    "data-name": "Path 10535",
    d: "M361.246,330.435c0,4.924-30.218,9.177-67.823,9.4-37.381.224-67.823-3.581-67.823-8.73,0-4.924,30.218-9.177,67.823-9.4C330.8,321.481,361.022,325.287,361.246,330.435Z",
    transform: "translate(-191.576 -300.217)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3341",
    "data-name": "Group 3341",
    transform: "matrix(1, -0.006, 0.006, 1, 0.002, 2.457)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 67.152,
    cy: 8.954,
    rx: 67.152,
    ry: 8.954,
    transform: "translate(34.024 21.489)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3342",
    "data-name": "Group 3342",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M358.436,330.311c0,4.924-29.771,9.177-66.256,9.177-36.71.224-66.48-3.581-66.48-8.506s29.771-9.177,66.256-9.177C328.666,321.581,358.436,325.387,358.436,330.311Z",
    transform: "translate(-191.453 -300.093)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3343",
    "data-name": "Group 3343",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10537",
    "data-name": "Path 10537",
    d: "M357.093,330.311c0,4.924-29.323,8.954-65.585,9.177s-65.809-3.581-65.809-8.506,29.323-8.954,65.585-9.177C327.77,321.581,357.093,325.387,357.093,330.311Z",
    transform: "translate(-191.453 -300.093)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10538",
    "data-name": "Path 10538",
    d: "M355.75,330.2c0,4.924-29.1,8.954-64.913,9.177S225.7,335.8,225.7,331.1c0-4.925,29.1-8.954,64.913-9.177C326.651,321.472,355.75,325.277,355.75,330.2Z",
    transform: "translate(-191.453 -299.984)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10539",
    "data-name": "Path 10539",
    d: "M354.507,330.188c0,4.7-28.651,8.73-64.242,8.954s-64.242-3.581-64.466-8.282c0-4.7,28.651-8.73,64.242-8.953S354.507,325.263,354.507,330.188Z",
    transform: "translate(-191.329 -299.969)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3346",
    "data-name": "Group 3346",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10540",
    "data-name": "Path 10540",
    d: "M353.04,330.187c0,4.7-28.428,8.73-63.57,8.954s-63.57-3.358-63.57-8.282,28.428-8.73,63.57-8.954C324.389,321.681,353.04,325.487,353.04,330.187Z",
    transform: "translate(-191.205 -299.969)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3347",
    "data-name": "Group 3347",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10541",
    "data-name": "Path 10541",
    d: "M351.7,330.064c0,4.7-28.2,8.506-62.9,8.73s-62.9-3.358-62.9-8.058,28.2-8.506,62.9-8.73S351.7,325.363,351.7,330.064Z",
    transform: "translate(-191.205 -299.846)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3348",
    "data-name": "Group 3348",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10542",
    "data-name": "Path 10542",
    d: "M350.354,330.064c0,4.7-27.756,8.506-62.227,8.73s-62.227-3.358-62.227-8.058,27.756-8.506,62.227-8.73S350.354,325.363,350.354,330.064Z",
    transform: "translate(-191.205 -299.846)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3349",
    "data-name": "Group 3349",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10543",
    "data-name": "Path 10543",
    d: "M349.111,329.94c0,4.477-27.532,8.506-61.556,8.506-34.024.224-61.556-3.358-61.556-7.834s27.532-8.506,61.556-8.506C321.355,321.882,348.888,325.24,349.111,329.94Z",
    transform: "translate(-191.081 -299.722)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10544",
    "data-name": "Path 10544",
    d: "M347.768,329.94c0,4.477-27.308,8.282-60.884,8.506S226,335.088,226,330.611s27.308-8.282,60.884-8.506S347.768,325.463,347.768,329.94Z",
    transform: "translate(-191.081 -299.722)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10545",
    "data-name": "Path 10545",
    d: "M346.425,329.94c0,4.477-26.861,8.282-60.213,8.506-33.128.224-60.213-3.357-60.213-7.834s26.861-8.282,60.213-8.506C319.341,321.882,346.425,325.463,346.425,329.94Z",
    transform: "translate(-191.081 -299.722)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352",
    transform: "matrix(1, -0.006, 0.006, 1, 0.002, 2.42)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 59.541,
    cy: 8.058,
    rx: 59.541,
    ry: 8.058,
    transform: "translate(34.919 22.384)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10546",
    "data-name": "Path 10546",
    d: "M343.615,329.816c0,4.253-26.189,8.058-58.646,8.282s-58.87-3.134-58.87-7.611c0-4.253,26.189-8.058,58.646-8.282C317.426,321.982,343.615,325.34,343.615,329.816Z",
    transform: "translate(-190.957 -299.598)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10547",
    "data-name": "Path 10547",
    d: "M342.372,329.693c0,4.253-25.965,7.834-57.974,8.058s-58.2-3.134-58.2-7.387,25.965-8.058,57.974-8.058C316.183,322.082,342.149,325.44,342.372,329.693Z",
    transform: "translate(-190.833 -299.474)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355",
    transform: "matrix(1, -0.006, 0.006, 1, 0.002, 2.41)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 57.303,
    cy: 7.611,
    rx: 57.303,
    ry: 7.611,
    transform: "translate(35.367 22.832)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10548",
    "data-name": "Path 10548",
    d: "M339.687,329.687c0,4.253-25.294,7.834-56.631,7.834-31.337.224-56.631-3.134-56.855-7.387s25.294-7.834,56.631-7.834S339.687,325.434,339.687,329.687Z",
    transform: "translate(-190.834 -299.469)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10549",
    "data-name": "Path 10549",
    d: "M338.219,329.569c0,4.253-25.07,7.611-55.96,7.834s-55.96-3.134-55.96-7.163c0-4.253,25.07-7.611,55.96-7.834S338.219,325.54,338.219,329.569Z",
    transform: "translate(-190.71 -299.35)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M336.876,329.563c0,4.029-24.622,7.611-55.288,7.834s-55.288-2.91-55.288-7.163c0-4.029,24.622-7.611,55.288-7.834C312.254,322.4,336.876,325.534,336.876,329.563Z",
    transform: "translate(-190.71 -299.345)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10551",
    "data-name": "Path 10551",
    d: "M335.633,329.445c0,4.029-24.4,7.387-54.617,7.611s-54.617-2.91-54.617-6.939,24.4-7.387,54.617-7.611C311.011,322.282,335.633,325.416,335.633,329.445Z",
    transform: "translate(-190.586 -299.227)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10552",
    "data-name": "Path 10552",
    d: "M334.29,329.445c0,4.029-24.175,7.387-53.945,7.611s-53.945-2.91-53.945-6.939,24.175-7.387,53.945-7.611S334.29,325.416,334.29,329.445Z",
    transform: "translate(-190.586 -299.227)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    transform: "matrix(1, -0.006, 0.006, 1, 0.001, 2.39)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_474",
    "data-name": "Ellipse 474",
    cx: 53.274,
    cy: 7.163,
    rx: 53.274,
    ry: 7.163,
    transform: "translate(35.814 23.503)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10553",
    "data-name": "Path 10553",
    d: "M331.6,329.322c0,3.805-23.5,7.163-52.6,7.387s-52.6-2.91-52.6-6.715,23.5-7.163,52.6-7.387S331.6,325.516,331.6,329.322Z",
    transform: "translate(-190.586 -299.103)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3363",
    "data-name": "Group 3363",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10554",
    "data-name": "Path 10554",
    d: "M330.261,329.315c0,3.805-23.279,7.163-51.931,7.163s-51.931-2.91-51.931-6.715,23.279-7.163,51.931-7.163S330.261,325.51,330.261,329.315Z",
    transform: "translate(-190.586 -299.097)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3364",
    "data-name": "Group 3364",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10555",
    "data-name": "Path 10555",
    d: "M328.894,329.2c0,3.805-22.832,6.939-51.035,7.163S226.6,333.675,226.6,329.87s22.832-6.939,51.035-7.163S328.894,325.393,328.894,329.2Z",
    transform: "translate(-190.338 -298.98)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10556",
    "data-name": "Path 10556",
    d: "M327.551,329.191c0,3.805-22.608,6.939-50.364,7.163-27.98.224-50.588-2.686-50.588-6.491s22.608-6.939,50.364-7.163C304.944,322.7,327.551,325.61,327.551,329.191Z",
    transform: "translate(-190.338 -298.973)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10557",
    "data-name": "Path 10557",
    d: "M326.208,329.191c0,3.581-22.16,6.715-49.692,6.939s-49.916-2.686-49.916-6.491c0-3.581,22.16-6.715,49.692-6.939C303.824,322.7,326.208,325.61,326.208,329.191Z",
    transform: "translate(-190.338 -298.973)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3367",
    "data-name": "Group 3367",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10558",
    "data-name": "Path 10558",
    d: "M324.865,329.074c0,3.581-21.936,6.715-49.021,6.939s-49.021-2.686-49.245-6.267c0-3.581,21.936-6.715,49.021-6.939C302.929,322.583,324.865,325.493,324.865,329.074Z",
    transform: "translate(-190.338 -298.856)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3368",
    "data-name": "Group 3368",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10559",
    "data-name": "Path 10559",
    d: "M323.5,329.068c0,3.581-21.712,6.715-48.349,6.715-26.637.224-48.349-2.686-48.349-6.268s21.712-6.715,48.349-6.715S323.275,325.486,323.5,329.068Z",
    transform: "translate(-190.09 -298.849)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10560",
    "data-name": "Path 10560",
    d: "M322.155,328.95c0,3.581-21.265,6.491-47.678,6.715s-47.678-2.686-47.678-6.044,21.265-6.491,47.678-6.715C300.667,322.683,322.155,325.593,322.155,328.95Z",
    transform: "translate(-190.09 -298.732)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10561",
    "data-name": "Path 10561",
    d: "M320.812,328.944c0,3.581-21.041,6.491-47.006,6.491-25.965.224-47.006-2.462-47.006-6.044s21.041-6.491,47.006-6.491S320.812,325.586,320.812,328.944Z",
    transform: "translate(-190.09 -298.726)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10562",
    "data-name": "Path 10562",
    d: "M319.469,329.051c0,3.358-20.817,6.267-46.335,6.491S226.8,333.08,226.8,329.5c0-3.358,20.817-6.268,46.335-6.491S319.469,325.469,319.469,329.051Z",
    transform: "translate(-190.09 -298.609)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372",
    transform: "matrix(1, -0.006, 0.006, 1, 0.001, 2.352)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 45.663,
    cy: 6.044,
    rx: 45.663,
    ry: 6.044,
    transform: "translate(36.71 24.622)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10563",
    "data-name": "Path 10563",
    d: "M316.883,328.927c0,3.358-20.145,6.044-44.992,6.267s-44.992-2.462-44.992-5.82,20.145-6.044,44.992-6.268S316.883,325.57,316.883,328.927Z",
    transform: "translate(-189.967 -298.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10564",
    "data-name": "Path 10564",
    d: "M315.54,328.8c0,3.358-19.7,6.044-44.32,6.267-24.4.224-44.32-2.462-44.32-5.6,0-3.358,19.7-6.044,44.32-6.267C295.619,322.984,315.54,325.446,315.54,328.8Z",
    transform: "translate(-189.967 -298.362)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10565",
    "data-name": "Path 10565",
    d: "M314.2,328.8c0,3.134-19.474,6.044-43.649,6.044-24.175.224-43.649-2.462-43.649-5.6s19.474-6.044,43.649-6.044C294.723,322.984,314.2,325.446,314.2,328.8Z",
    transform: "translate(-189.967 -298.362)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10566",
    "data-name": "Path 10566",
    d: "M312.73,328.8c0,3.134-19.25,5.82-42.753,6.044-23.727.224-42.977-2.238-42.977-5.6,0-3.134,19.25-5.82,42.753-6.044C293.48,322.984,312.73,325.446,312.73,328.8Z",
    transform: "translate(-189.843 -298.362)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10567",
    "data-name": "Path 10567",
    d: "M311.387,328.68c0,3.134-18.8,5.82-42.082,5.82-23.279.224-42.306-2.238-42.306-5.372s18.8-5.82,42.082-5.82C292.585,323.084,311.387,325.546,311.387,328.68Z",
    transform: "translate(-189.843 -298.238)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10568",
    "data-name": "Path 10568",
    d: "M310.144,328.68c0,3.134-18.579,5.6-41.41,5.82s-41.41-2.238-41.634-5.372c0-3.134,18.579-5.6,41.41-5.82C291.566,323.084,310.144,325.546,310.144,328.68Z",
    transform: "translate(-189.719 -298.238)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379",
    transform: "matrix(1, -0.006, 0.006, 1, 0.002, 2.328)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 40.739,
    cy: 5.372,
    rx: 40.739,
    ry: 5.372,
    transform: "translate(37.605 25.294)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10569",
    "data-name": "Path 10569",
    d: "M307.334,328.557c0,2.91-17.907,5.6-40.067,5.6-22.16.224-40.067-2.238-40.067-5.148s17.907-5.6,40.067-5.6C289.427,323.185,307.334,325.423,307.334,328.557Z",
    transform: "translate(-189.595 -298.115)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10570",
    "data-name": "Path 10570",
    d: "M305.991,328.548c0,2.91-17.683,5.372-39.4,5.6s-39.4-2.238-39.4-5.148,17.683-5.372,39.4-5.6C288.308,323.4,305.991,325.638,305.991,328.548Z",
    transform: "translate(-189.595 -298.106)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10571",
    "data-name": "Path 10571",
    d: "M304.748,328.433c0,2.91-17.236,5.372-38.724,5.372-21.489.224-38.724-2.015-38.724-4.924s17.236-5.372,38.724-5.372C287.289,323.285,304.524,325.523,304.748,328.433Z",
    transform: "translate(-189.471 -297.991)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10572",
    "data-name": "Path 10572",
    d: "M303.405,328.433c0,2.91-17.012,5.148-38.053,5.372s-38.053-2.015-38.053-4.924,17.012-5.148,38.053-5.372S303.405,325.523,303.405,328.433Z",
    transform: "translate(-189.471 -297.991)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10573",
    "data-name": "Path 10573",
    d: "M302.062,328.3c0,2.686-16.788,5.148-37.381,5.148-20.593.224-37.381-2.015-37.381-4.7s16.788-5.148,37.381-5.148S302.062,325.615,302.062,328.3Z",
    transform: "translate(-189.471 -297.859)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10574",
    "data-name": "Path 10574",
    d: "M300.719,328.309c0,2.686-16.34,4.924-36.71,5.148-20.146.224-36.71-2.015-36.71-4.7s16.34-4.924,36.71-5.148S300.719,325.623,300.719,328.309Z",
    transform: "translate(-189.471 -297.867)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10575",
    "data-name": "Path 10575",
    d: "M299.376,328.3c0,2.686-16.116,4.924-36.038,4.924-19.922.224-36.038-2.015-36.038-4.7s16.116-4.924,36.038-4.924S299.376,325.615,299.376,328.3Z",
    transform: "translate(-189.471 -297.859)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10576",
    "data-name": "Path 10576",
    d: "M298.009,328.177c0,2.686-15.669,4.924-35.143,4.924s-35.366-2.015-35.366-4.477c0-2.686,15.669-4.924,35.143-4.924S298.009,325.491,298.009,328.177Z",
    transform: "translate(-189.224 -297.735)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10577",
    "data-name": "Path 10577",
    d: "M296.666,328.177c0,2.462-15.445,4.7-34.471,4.924-19.026,0-34.695-1.791-34.695-4.477,0-2.462,15.445-4.7,34.471-4.924C281.221,323.7,296.666,325.715,296.666,328.177Z",
    transform: "translate(-189.224 -297.735)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10578",
    "data-name": "Path 10578",
    d: "M295.323,328.062c0,2.462-15.221,4.7-33.8,4.7-18.8,0-33.8-1.791-34.023-4.253,0-2.462,15.221-4.7,33.8-4.7C280.1,323.586,295.323,325.6,295.323,328.062Z",
    transform: "translate(-189.224 -297.62)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390",
    transform: "matrix(1, -0.006, 0.006, 1, 0.002, 2.29)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 33.128,
    cy: 4.477,
    rx: 33.128,
    ry: 4.477,
    transform: "translate(38.5 26.189)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10579",
    "data-name": "Path 10579",
    d: "M292.513,328.053c0,2.462-14.549,4.477-32.457,4.477s-32.457-1.791-32.457-4.253,14.55-4.477,32.457-4.477S292.513,325.591,292.513,328.053Z",
    transform: "translate(-189.1 -297.611)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10580",
    "data-name": "Path 10580",
    d: "M291.27,327.939c0,2.462-14.326,4.253-31.785,4.477-17.459,0-31.785-1.791-31.785-4.029,0-2.462,14.326-4.253,31.785-4.477S291.27,325.7,291.27,327.939Z",
    transform: "translate(-188.976 -297.497)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10581",
    "data-name": "Path 10581",
    d: "M289.927,327.929c0,2.238-13.878,4.253-31.114,4.253s-31.114-1.791-31.114-4.029,13.878-4.253,31.114-4.253S289.927,325.691,289.927,327.929Z",
    transform: "translate(-188.976 -297.487)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10582",
    "data-name": "Path 10582",
    d: "M288.584,327.816c0,2.238-13.654,4.253-30.442,4.253S227.7,330.5,227.7,328.263s13.654-4.253,30.442-4.253C274.93,323.787,288.584,325.577,288.584,327.816Z",
    transform: "translate(-188.976 -297.374)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10583",
    "data-name": "Path 10583",
    d: "M287.241,327.805c0,2.238-13.206,4.029-29.771,4.253-16.34,0-29.771-1.567-29.771-3.805s13.206-4.029,29.771-4.253C274.035,324,287.241,325.567,287.241,327.805Z",
    transform: "translate(-188.976 -297.363)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10584",
    "data-name": "Path 10584",
    d: "M285.9,327.805c0,2.238-12.983,4.029-29.1,4.029s-29.1-1.567-29.1-3.805S240.683,324,256.8,324,285.9,325.791,285.9,327.805Z",
    transform: "translate(-188.976 -297.363)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10585",
    "data-name": "Path 10585",
    d: "M284.655,327.682c0,2.015-12.759,3.805-28.428,4.029-15.669,0-28.428-1.567-28.428-3.581s12.759-3.805,28.428-4.029C271.9,324.1,284.655,325.667,284.655,327.682Z",
    transform: "translate(-188.852 -297.239)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10586",
    "data-name": "Path 10586",
    d: "M283.188,327.682c0,2.015-12.311,3.805-27.532,3.805S227.9,329.92,227.9,327.905s12.311-3.805,27.532-3.805S283.188,325.667,283.188,327.682Z",
    transform: "translate(-188.728 -297.239)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399",
    transform: "matrix(1, -0.006, 0.006, 1, 0, 2.26)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_516",
    "data-name": "Ellipse 516",
    cx: 27.084,
    cy: 3.581,
    rx: 27.084,
    ry: 3.581,
    transform: "translate(39.172 27.084)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10587",
    "data-name": "Path 10587",
    d: "M280.5,327.558c0,2.014-11.64,3.581-26.189,3.581s-26.189-1.343-26.413-3.358,11.64-3.581,26.189-3.581S280.5,325.767,280.5,327.558Z",
    transform: "translate(-188.73 -297.116)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401",
    transform: "matrix(1, -0.006, 0.006, 1, 0.004, 2.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_519",
    "data-name": "Ellipse 519",
    cx: 25.518,
    cy: 3.358,
    rx: 25.518,
    ry: 3.358,
    transform: "translate(39.396 27.308)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402",
    transform: "matrix(1, -0.006, 0.006, 1, 0.001, 2.249)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_521",
    "data-name": "Ellipse 521",
    cx: 24.846,
    cy: 3.358,
    rx: 24.846,
    ry: 3.358,
    transform: "translate(39.619 27.308)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3403",
    "data-name": "Group 3403",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10588",
    "data-name": "Path 10588",
    d: "M276.449,327.547c0,1.791-10.744,3.358-24.175,3.358s-24.175-1.343-24.175-3.134,10.744-3.358,24.175-3.358C265.481,324.19,276.449,325.533,276.449,327.547Z",
    transform: "translate(-188.481 -296.881)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10589",
    "data-name": "Path 10589",
    d: "M275.106,327.534c0,1.791-10.521,3.134-23.5,3.358-12.983,0-23.5-1.343-23.5-3.134s10.52-3.134,23.5-3.358C264.586,324.4,275.106,325.743,275.106,327.534Z",
    transform: "translate(-188.481 -296.868)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10590",
    "data-name": "Path 10590",
    d: "M273.763,327.423c0,1.791-10.3,3.134-22.832,3.134s-22.831-1.343-22.831-2.91c0-1.791,10.3-3.134,22.831-3.134C263.69,324.29,273.763,325.633,273.763,327.423Z",
    transform: "translate(-188.481 -296.758)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10591",
    "data-name": "Path 10591",
    d: "M272.52,327.41c0,1.567-9.849,3.134-22.16,3.134s-22.16-1.119-22.16-2.91c0-1.567,9.849-3.134,22.16-3.134C262.447,324.5,272.52,325.619,272.52,327.41Z",
    transform: "translate(-188.357 -296.744)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10592",
    "data-name": "Path 10592",
    d: "M271.177,327.3c0,1.567-9.625,2.91-21.489,2.91S228.2,329.09,228.2,327.523s9.625-2.91,21.489-2.91C261.552,324.39,271.177,325.733,271.177,327.3Z",
    transform: "translate(-188.357 -296.634)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10593",
    "data-name": "Path 10593",
    d: "M269.834,327.286c0,1.567-9.177,2.91-20.817,2.91-11.416,0-20.817-1.119-20.817-2.686s9.177-2.91,20.817-2.91S269.834,325.719,269.834,327.286Z",
    transform: "translate(-188.357 -296.62)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3409",
    "data-name": "Group 3409",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10594",
    "data-name": "Path 10594",
    d: "M268.491,327.286c0,1.567-8.954,2.686-20.146,2.91-10.968,0-20.145-1.119-20.145-2.686s8.954-2.686,20.145-2.91C259.537,324.6,268.491,325.719,268.491,327.286Z",
    transform: "translate(-188.357 -296.62)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3410",
    "data-name": "Group 3410",
    transform: "matrix(1, -0.006, 0.006, 1, 0.001, 2.222)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 19.474,
    cy: 2.686,
    rx: 19.474,
    ry: 2.686,
    transform: "translate(40.067 27.98)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10595",
    "data-name": "Path 10595",
    d: "M265.657,327.162c0,1.343-8.282,2.462-18.579,2.686-10.3,0-18.579-1.119-18.579-2.462s8.282-2.462,18.579-2.686C257.151,324.7,265.657,325.819,265.657,327.162Z",
    transform: "translate(-187.985 -296.496)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10596",
    "data-name": "Path 10596",
    d: "M264.314,327.054c0,1.343-8.058,2.462-17.907,2.462s-17.907-.9-17.907-2.238,8.058-2.462,17.907-2.462C256.256,324.592,264.314,325.711,264.314,327.054Z",
    transform: "translate(-187.985 -296.388)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10597",
    "data-name": "Path 10597",
    d: "M262.971,327.038c0,1.343-7.834,2.462-17.236,2.462-9.625,0-17.236-.9-17.236-2.238s7.834-2.462,17.236-2.462S262.971,325.7,262.971,327.038Z",
    transform: "translate(-187.985 -296.373)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10598",
    "data-name": "Path 10598",
    d: "M261.628,327.038c0,1.119-7.387,2.238-16.564,2.238s-16.564-.9-16.564-2.238c0-1.119,7.387-2.238,16.564-2.238S261.628,325.7,261.628,327.038Z",
    transform: "translate(-187.985 -296.373)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10599",
    "data-name": "Path 10599",
    d: "M260.385,326.915c0,1.119-7.163,2.238-15.893,2.238s-15.893-.9-15.893-2.014,7.163-2.238,15.893-2.238S260.161,325.8,260.385,326.915Z",
    transform: "translate(-187.861 -296.249)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10600",
    "data-name": "Path 10600",
    d: "M259.042,326.915c0,1.119-6.715,2.015-15.221,2.238-8.506,0-15.221-.9-15.221-2.014s6.715-2.015,15.221-2.238C252.1,324.9,259.042,325.8,259.042,326.915Z",
    transform: "translate(-187.861 -296.249)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10601",
    "data-name": "Path 10601",
    d: "M257.7,326.81c0,1.119-6.491,2.015-14.55,2.015s-14.55-.9-14.55-1.791,6.491-2.015,14.55-2.015C251.208,324.8,257.7,325.691,257.7,326.81Z",
    transform: "translate(-187.861 -296.144)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10602",
    "data-name": "Path 10602",
    d: "M256.356,326.791c0,1.119-6.267,1.791-13.878,2.015-7.611,0-13.878-.672-13.878-1.791s6.268-1.791,13.878-2.015C250.089,325,256.356,325.672,256.356,326.791Z",
    transform: "translate(-187.861 -296.125)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M255.013,326.791c0,.9-5.82,1.791-13.206,1.791-7.163,0-13.206-.672-13.206-1.791S234.42,325,241.806,325,255.013,325.9,255.013,326.791Z",
    transform: "translate(-187.861 -296.125)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3420",
    "data-name": "Group 3420",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M253.77,326.667c0,.9-5.6,1.791-12.535,1.791s-12.535-.672-12.535-1.567,5.6-1.791,12.535-1.791S253.77,325.772,253.77,326.667Z",
    transform: "translate(-187.737 -296.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M252.3,326.667c0,.9-5.148,1.567-11.64,1.567s-11.863-.672-11.863-1.567,5.148-1.567,11.64-1.567S252.3,325.772,252.3,326.667Z",
    transform: "translate(-187.614 -296.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M250.836,326.543c0,.9-4.924,1.567-10.968,1.567s-10.968-.671-10.968-1.343c0-.9,4.924-1.567,10.968-1.567S250.836,325.648,250.836,326.543Z",
    transform: "translate(-187.49 -295.877)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10607",
    "data-name": "Path 10607",
    d: "M249.493,326.543c0,.671-4.7,1.343-10.3,1.343-5.82,0-10.3-.672-10.3-1.343s4.7-1.343,10.3-1.343S249.493,325.872,249.493,326.543Z",
    transform: "translate(-187.49 -295.877)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10608",
    "data-name": "Path 10608",
    d: "M248.15,326.543c0,.671-4.253,1.343-9.625,1.343s-9.625-.448-9.625-1.343c0-.672,4.253-1.343,9.625-1.343S248.15,325.872,248.15,326.543Z",
    transform: "translate(-187.49 -295.877)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609",
    "data-name": "Path 10609",
    d: "M246.907,326.419c0,.671-4.029,1.119-8.954,1.343-4.924,0-8.954-.448-8.954-1.119s4.029-1.119,8.954-1.343C242.878,325.3,246.907,325.748,246.907,326.419Z",
    transform: "translate(-187.366 -295.753)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10610",
    "data-name": "Path 10610",
    d: "M245.564,326.419c0,.671-3.805,1.119-8.282,1.119S229,327.091,229,326.419s3.805-1.119,8.282-1.119S245.564,325.748,245.564,326.419Z",
    transform: "translate(-187.366 -295.753)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10611",
    "data-name": "Path 10611",
    d: "M244.221,326.3c0,.671-3.358,1.119-7.611,1.119s-7.61-.448-7.61-.9c0-.672,3.358-1.119,7.61-1.119S244.221,325.848,244.221,326.3Z",
    transform: "translate(-187.366 -295.629)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M242.878,326.3c0,.448-3.134.9-6.939.9s-6.939-.448-6.939-.9,3.134-.9,6.939-.9S242.878,325.848,242.878,326.3Z",
    transform: "translate(-187.366 -295.629)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10613",
    "data-name": "Path 10613",
    d: "M241.535,326.3c0,.448-2.686.9-6.268.9-3.358,0-6.267-.448-6.267-.9s2.686-.9,6.267-.9C238.849,325.624,241.535,325.848,241.535,326.3Z",
    transform: "translate(-187.366 -295.629)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10614",
    "data-name": "Path 10614",
    d: "M240.292,326.171c0,.448-2.462.672-5.6.672s-5.6-.224-5.6-.672,2.462-.671,5.6-.671S240.292,325.948,240.292,326.171Z",
    transform: "translate(-187.242 -295.506)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10615",
    "data-name": "Path 10615",
    d: "M238.949,326.171c0,.448-2.238.672-4.924.672s-4.924-.224-4.924-.672,2.238-.671,4.924-.671C236.711,325.724,238.949,325.948,238.949,326.171Z",
    transform: "translate(-187.242 -295.506)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10616",
    "data-name": "Path 10616",
    d: "M237.606,326.048c0,.224-1.791.672-4.253.672-2.238,0-4.253-.224-4.253-.448s1.791-.671,4.253-.671S237.606,325.824,237.606,326.048Z",
    transform: "translate(-187.242 -295.382)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10617",
    "data-name": "Path 10617",
    d: "M236.015,326.048c0,.224-1.567.448-3.358.448-2.015,0-3.358-.224-3.358-.448s1.567-.448,3.358-.448S236.015,325.824,236.015,326.048Z",
    transform: "translate(-186.994 -295.382)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10618",
    "data-name": "Path 10618",
    d: "M234.772,326.048c0,.224-1.343.448-2.686.448-1.567,0-2.686-.224-2.686-.448s1.343-.448,2.686-.448Z",
    transform: "translate(-186.871 -295.382)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10619",
    "data-name": "Path 10619",
    d: "M233.429,325.924c0,.224-.9.224-2.015.224a9.232,9.232,0,0,1-2.015-.224c0-.224.9-.224,2.015-.224A9.244,9.244,0,0,1,233.429,325.924Z",
    transform: "translate(-186.871 -295.258)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10620",
    "data-name": "Path 10620",
    d: "M232.086,326.024a4.879,4.879,0,0,1-1.343.224c-.671,0-1.343,0-1.343-.224a4.878,4.878,0,0,1,1.343-.224C231.415,325.8,232.086,325.8,232.086,326.024Z",
    transform: "translate(-186.871 -295.134)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437",
    transform: "translate(0.166 1.874)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10621",
    "data-name": "Path 10621",
    d: "M230.743,325.993h-.671Q230.743,325.657,230.743,325.993Z",
    transform: "translate(-186.871 -295.103)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440",
    transform: "translate(18.803 76.255)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10622",
    "data-name": "Path 10622",
    d: "M218.447,232.859,195.616,220.1,184.2,223.234l22.832,12.983Z",
    transform: "translate(-81.234 -92.736)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10623",
    "data-name": "Path 10623",
    d: "M197,194.1l3.358,11.64,22.832,12.983-3.358-11.863Z",
    transform: "translate(-65.383 -124.934)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10624",
    "data-name": "Path 10624",
    d: "M145.234,205.016l22.832,12.759-3.134-11.416L142.1,193.6Z",
    transform: "translate(-133.37 -125.553)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10625",
    "data-name": "Path 10625",
    d: "M205.873,205.8l6.491,23.279-16.564,4.7,22.832,12.759,16.564-4.7L228.7,218.783Z",
    transform: "translate(-66.869 -110.445)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10626",
    "data-name": "Path 10626",
    d: "M165.732,220.788l-4.7-16.564,75.658-21.265L214.081,170.2,138.2,191.465l4.7,16.564Z",
    transform: "translate(-138.2 -154.531)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10627",
    "data-name": "Path 10627",
    d: "M209.2,243.867l-31.337,8.73-8.73-31.114L146.3,208.5l18.8,66.928,66.928-18.8Z",
    transform: "translate(-128.169 -107.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10628",
    "data-name": "Path 10628",
    d: "M178.5,174.616,201.332,187.6l7.163,3.805,22.832,12.983L219.686,163.2Z",
    transform: "translate(-88.293 -163.2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10629",
    "data-name": "Path 10629",
    d: "M193.7,182.3l3.358,11.863,22.832,12.759-3.358-11.64Z",
    transform: "translate(-69.469 -139.547)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441",
    transform: "translate(0 21.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10630",
    "data-name": "Path 10630",
    d: "M264.4,235.193H220.3L236.193,219.3h44.1Zm-35.814-3.358h34.471l9.177-9.177H237.536Z",
    transform: "translate(-17.726 -38.886)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10631",
    "data-name": "Path 10631",
    d: "M277.336,195.84h-44.1L216.9,179.5H261Zm-42.753-3.358h34.471l-9.625-9.625H224.958Z",
    transform: "translate(-21.936 -88.174)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10632",
    "data-name": "Path 10632",
    d: "M204.389,235.193h-44.1L144.4,219.3h44.1Zm-42.529-3.358h34.471l-9.177-9.177H152.682Z",
    transform: "translate(-111.72 -38.886)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10633",
    "data-name": "Path 10633",
    d: "M281.159,239.854h-44.1l20.146-20.145L229.9,192.4H274L301.3,219.708ZM245.121,236.5h34.471l16.788-16.788-23.951-23.951H237.958l23.951,23.951Z",
    transform: "translate(-5.837 -72.199)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10634",
    "data-name": "Path 10634",
    d: "M194.042,272.052h-44.1L129.8,251.906,215.306,166.4h44.1L173.9,251.906Zm-42.753-3.358H185.76l-16.788-16.788,82.149-81.925H216.649l-81.925,81.925Z",
    transform: "translate(-129.8 -104.397)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10635",
    "data-name": "Path 10635",
    d: "M238.9,313.7,161,235.8h44.1l33.8,33.8,33.8-33.8h44.1Zm-69.838-74.538L238.9,309l69.838-69.838H274.262L238.9,274.3l-35.367-35.143Z",
    transform: "translate(-91.162 -18.453)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10636",
    "data-name": "Path 10636",
    d: "M272.637,188.168H173.7L223.168,138.7Zm-90.879-3.358h82.82l-41.41-41.41Z",
    transform: "translate(-75.435 -138.7)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10637",
    "data-name": "Path 10637",
    d: "M264.336,182.84h-44.1L203.9,166.5H248Zm-42.753-3.358h34.471l-9.625-9.625H211.958Z",
    transform: "translate(-38.035 -104.273)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443",
    transform: "translate(546.865 42.424)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10638",
    "data-name": "Path 10638",
    d: "M525.331,223.327h0v-.672c-.9-2.015-2.238-4.029-4.029-4.924l-.448-.224h0L461.537,183.26l-59.093-34.247h0l-.448-.224a5.491,5.491,0,0,0-4.924-.224h-.448l-7.834,4.477,4.477,2.015L377.6,237.876a11.737,11.737,0,0,0,.9,6.715v.448c.9,2.015,2.238,4.029,4.029,4.924l117.963,68.047-1.119,5.148,7.387-4.253h.224a6.15,6.15,0,0,0,2.91-4.477l15.893-84.835A8.712,8.712,0,0,0,525.331,223.327Z",
    transform: "translate(-370.013 -148.086)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(0 4.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10639",
    "data-name": "Path 10639",
    d: "M498.54,320.7,379.234,251.762c-3.581-2.015-5.82-7.611-4.924-12.535l15.669-83.492c.9-4.7,4.477-6.939,8.058-4.924l119.306,68.942c3.581,2.015,5.82,7.611,4.924,12.535L506.6,315.779C505.926,320.48,502.121,322.718,498.54,320.7Z",
    transform: "translate(-374.112 -150.069)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10640",
    "data-name": "Path 10640",
    d: "M480.972,200.047,421.879,165.8,403.3,264.065,461.946,301c3.805,2.238,7.61.448,8.506-4.029l15.893-84.835A12.181,12.181,0,0,0,480.972,200.047Z",
    transform: "translate(-337.966 -130.587)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10641",
    "data-name": "Path 10641",
    d: "M398.883,151.133l59.093,34.247-18.355,97.594-59.765-30.89c-3.805-2.238-6.268-7.611-5.6-12.087l15.893-84.835C391.049,150.685,394.854,148.895,398.883,151.133Z",
    transform: "translate(-374.064 -149.944)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10642",
    "data-name": "Path 10642",
    d: "M374.5,205.979a12.145,12.145,0,0,0,4.7,5.82L497.388,280.07a6.017,6.017,0,0,0,5.82.224L450.158,182.7Z",
    transform: "translate(-373.631 -109.659)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10643",
    "data-name": "Path 10643",
    d: "M511.307,225.072a12.146,12.146,0,0,0-4.7-5.82L388.42,150.981a6.017,6.017,0,0,0-5.82-.224l53.05,97.594Z",
    transform: "translate(-363.6 -150.016)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445",
    transform: "translate(147.694 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10644",
    "data-name": "Path 10644",
    d: "M198.06,318.651h0c0-.224.224-.448.224-.672s.224-.224.224-.448.224-.224.224-.448c2.238-5.372,5.82-9.849,10.073-12.311l1.119-.672h0l149.3-86.178,149.3-86.178h0l1.119-.672a12.793,12.793,0,0,1,12.311-.672,1857.658,1857.658,0,0,1,.448.448l19.7,11.416-11.416,4.924,39.4,209.065a27.587,27.587,0,0,1-2.238,16.788c0,.224-.224.224-.224.448s-.224.224-.224.448c-2.238,5.372-5.82,9.849-10.073,12.311L259.392,558.382l2.686,13.206L243.5,560.844a.219.219,0,0,1-.224-.224,15.346,15.346,0,0,1-7.387-11.192L196.27,334.767A28.507,28.507,0,0,1,198.06,318.651Z",
    transform: "translate(-195.782 -129.133)",
    fill: "url(#linear-gradient-540)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444",
    transform: "translate(19.496 10.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10645",
    "data-name": "Path 10645",
    d: "M265.517,564.957,566.58,391.035c9.177-5.148,14.549-19.474,12.311-31.561l-39.843-211.08c-2.238-12.087-11.64-17.683-20.593-12.535L217.391,309.781c-9.177,5.148-14.55,19.474-12.311,31.561l39.843,211.08C247.162,564.733,256.339,570.329,265.517,564.957Z",
    transform: "translate(-204.391 -133.945)",
    fill: "url(#linear-gradient-540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10646",
    "data-name": "Path 10646",
    d: "M218.612,259.978l149.3-86.178,46.782,248.013L266.737,514.93c-9.849,5.6-19.474,1.119-21.489-10.3L204.957,290.42C202.719,279.228,208.763,265.574,218.612,259.978Z",
    transform: "translate(-204.492 -84.59)",
    fill: "url(#linear-gradient-540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10647",
    "data-name": "Path 10647",
    d: "M426.9,136.533,277.6,222.711l46.559,246.446,150.867-77.672c9.849-5.6,15.893-19.474,13.878-30.666L448.613,146.606C446.151,135.414,436.526,130.937,426.9,136.533Z",
    transform: "translate(-113.956 -133.724)",
    fill: "url(#linear-gradient-540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10648",
    "data-name": "Path 10648",
    d: "M550.914,275.17c-2.462,6.044-6.715,11.64-11.863,14.549L240.45,462.3c-5.372,3.134-10.52,3.134-14.549.671L359.756,216.3Z",
    transform: "translate(-177.981 -31.958)",
    fill: "url(#linear-gradient-540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10649",
    "data-name": "Path 10649",
    d: "M205.5,323.68c2.462-6.044,6.715-11.64,11.863-14.549l298.6-172.58c5.372-3.134,10.521-3.134,14.55-.672L396.882,382.326Z",
    transform: "translate(-203.244 -133.742)",
    fill: "url(#linear-gradient-540)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(676.305 245.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 4.029,
    height: 4.029,
    transform: "translate(2.849 5.131) rotate(45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 4.029,
    height: 4.029,
    transform: "translate(12.942 5.012) rotate(45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 4.029,
    height: 4.029,
    transform: "translate(7.688 0) rotate(45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 4.029,
    height: 4.029,
    transform: "translate(7.787 10.143) rotate(45)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(-1040.054 -2355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "isomatric_coin",
    "data-name": "isomatric coin",
    d: "M24.165,11.987a7.236,7.236,0,0,1,.716,2.943,3.792,3.792,0,0,1-2.712,3.8,7.236,7.236,0,0,1-3.015.282m-5.538-13.4a4.917,4.917,0,0,0-2.467.982A3.605,3.605,0,0,0,9.89,8.624a5.523,5.523,0,0,0,.14,2.76,10.462,10.462,0,0,0,1.518,3.074m18.9-.959c3.045,6.68-.41,11.525-7.718,10.823S7.032,17.634,3.986,10.955,4.4-.571,11.7.132,27.4,6.819,30.449,13.5Zm-.246-.418c3.774,6.994.528,14.466-7.416,14.238S5.345,21.237,1.57,14.243,1.042-.223,8.986.005,26.429,6.088,30.2,13.081Z",
    transform: "translate(1254.352 2863.702)",
    fill: "none",
    stroke: "#e4eff7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(1629.781 2711.979) rotate(-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M7.094,1.192.909,6.468,0,0Z",
    transform: "translate(13.461 29.651)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M.445,0,0,29.186a2.071,2.071,0,0,0,2.1,2.1l29.308-.647a.819.819,0,0,0,.546-1.415Z",
    fill: "url(#linear-gradient-551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769",
    "data-name": "Path 9769",
    d: "M20.111,30.844,0,0,15.382,30.965,13.724,32.5Z",
    transform: "translate(0.445 0)",
    fill: "url(#linear-gradient-552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770",
    "data-name": "Path 9770",
    d: "M0,.06,1.354,5.154,2.809,0Z",
    transform: "translate(13.017 30.965)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass_Triangle1",
    "data-name": "Glass Triangle1",
    transform: "matrix(0.934, 0.358, -0.358, 0.934, 1132.117, 2769.198)",
    fill: "rgba(255,255,255,0.3)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.887,31.774,31.774,0H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.88703536987305 27.30194473266602 L 28.53800964355469 2.000004529953003 L 3.236068964004517 2.000004529953003 L 15.88703536987305 27.30194473266602 M 15.88703441619873 31.77407455444336 L 4.41619886260014e-06 4.41619886260014e-06 L 31.77407455444336 4.41619886260014e-06 L 15.88703441619873 31.77407455444336 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_2",
    "data-name": "coin 2",
    transform: "translate(1342.015 2356.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9911",
    "data-name": "Path 9911",
    d: "M67.662,76.942s5.7,1.517,9.425-1.885,2.424-9.425,2.424-9.425",
    transform: "translate(-58.344 -56.746)",
    fill: "none",
    stroke: "#e4eff7",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9912",
    "data-name": "Path 9912",
    d: "M41.946,31.261s-5.771-1.211-9.311,2.385-1.918,9.541-1.918,9.541",
    transform: "translate(-26.468 -26.801)",
    fill: "none",
    stroke: "#e4eff7",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 12.5,
    cy: 12.054,
    rx: 12.5,
    ry: 12.054,
    transform: "translate(-0.015 0.36)",
    fill: "none",
    stroke: "#e4eff7",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactformillustration);
export default __webpack_public_path__ + "static/media/contactform illustration.364ae83fcbc12c026cf95d970eb840a7.svg";
export { ForwardRef as ReactComponent };